import React from 'react';
import { Box, TextField, MenuItem } from '@mui/material';
import config from '@/config';
import { TimeType } from '@/api/userApi';
import { TradingEnvironment } from '@/data/tradingEnvironment';
import { useTradingAccount } from '@/contexts/TradingAccountContext';

interface TimeTypeSelectorProps {
  selectedTimeType: TimeType;
  onTimeTypeChange: (timeType: TimeType) => void;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  label?: string;
}

const TimeTypeSelector: React.FC<TimeTypeSelectorProps> = ({ selectedTimeType, onTimeTypeChange, size = 'small', fullWidth = true, label = 'Time in Force' }) => {
  const { tradingEnvironment } = useTradingAccount();
  const isLiveEnv = tradingEnvironment === TradingEnvironment.Live;
  const handleTimeTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value) as TimeType;
    onTimeTypeChange(value ? value : TimeType.Day);
  };

  return (
    <>
      <Box>
        {isLiveEnv && config.features.supportTimeType === true && (
          <TextField
            select
            fullWidth={fullWidth}
            size={size}
            label={label}
            value={selectedTimeType}
            onChange={handleTimeTypeChange}
          >
            <MenuItem value={TimeType.Day} key={TimeType.Day}>
              Day
            </MenuItem>
            <MenuItem value={TimeType.GoodTillCancelled} key={TimeType.GoodTillCancelled}>
              Good Till Cancelled
            </MenuItem>
          </TextField>
        )}
      </Box>
    </>
  );
};

export default TimeTypeSelector;
